import {Types} from "../type/Types";

export type ResponseWrapper<T> = {
    metadata: ResponseWrapper.Metadata
    result: T
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace ResponseWrapper {
    export function construct<T>(o: any, construct: (o: any) => T): ResponseWrapper<T> {
        return {
            metadata: Metadata.construct(o.metadata),
            result: construct(o.result)
        }
    }

    export type Metadata = {
        acceptedAt: Date
        respondedAt: Date
    }

    export namespace Metadata {
        export function construct(o: any): Metadata {
            return {
                acceptedAt: new Date(o.acceptedAt),
                respondedAt: new Date(o.respondedAt)
            }
        }
    }
}

export class ErrorResponse extends Error {
    typeName: ErrorResponse.WellKnown

    constructor(o: any) {
        super(Types.asUndefined(o.message, String));

        this.typeName = String(o.typeName) as ErrorResponse.WellKnown
    }

    raise(): never {
        // this is Error
        // eslint-disable-next-line no-throw-literal
        throw this
    }

    stringify(): string {
        return 'name:' + this.name + '\ntypeName:' + this.typeName + '\nmessage:' + this.message + '\nstack' + this.stack + '\ncause:' + this.cause
    }
}

export namespace ErrorResponse {
    export function construct(o: any): ErrorResponse {
        return new ErrorResponse(o)
    }

    export type WellKnown =
        'kr.co.vowing.nsrt.model.dto.Error$EnvNaverSearchKey$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$EnvNaverSearchKey$InsufficientDataTransferObject' |
        'kr.co.vowing.nsrt.model.dto.Error$Shopping$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$Shopping$InsufficientDataTransferObject' |
        'kr.co.vowing.nsrt.model.dto.Error$ShoppingError$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$ShoppingError$InsufficientDataTransferObject' |
        'kr.co.vowing.nsrt.model.dto.Error$ShoppingModification$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$ShoppingSchedule$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$User$Unauthorized' |
        'kr.co.vowing.nsrt.model.dto.Error$User$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$UserSession$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$UserSignIn$Already' |
        'kr.co.vowing.nsrt.model.dto.Error$UserSignIn$NotFound' |
        'kr.co.vowing.nsrt.model.dto.Error$UserSignIn$InsufficientDataTransferObject'

    export namespace WellKnown {
        export const description: Record<WellKnown, string> = {
            'kr.co.vowing.nsrt.model.dto.Error$EnvNaverSearchKey$NotFound': '네이버 검색 키를 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$EnvNaverSearchKey$InsufficientDataTransferObject': '잘못된 쇼핑 요청 데이터입니다.',
            'kr.co.vowing.nsrt.model.dto.Error$Shopping$NotFound': '쇼핑을 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$Shopping$InsufficientDataTransferObject': '잘못된 쇼핑 요청 데이터입니다.',
            'kr.co.vowing.nsrt.model.dto.Error$ShoppingError$NotFound': '쇼핑 오류를 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$ShoppingError$InsufficientDataTransferObject': '잘못된 쇼핑 요청 데이터입니다.',
            'kr.co.vowing.nsrt.model.dto.Error$ShoppingModification$NotFound': '쇼핑 수정 이력을 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$ShoppingSchedule$NotFound': '쇼핑 갱신 일정을 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$User$Unauthorized': '권한이 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$User$NotFound': '사용자를 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$UserSession$NotFound': '사용자 세션을 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$UserSignIn$Already': '이미 로그인되어 있습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$UserSignIn$NotFound': '사용자 로그인을 찾을 수 없습니다.',
            'kr.co.vowing.nsrt.model.dto.Error$UserSignIn$InsufficientDataTransferObject': '잘못된 사용자 로그인 요청 데이터입니다.',
        }
    }
}